import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "@/i18n";
import { BRAND, CONTACT, SOCIAL, waLink } from "@/config";
import { Instagram, Facebook, MessageCircle } from "lucide-react";

export default function Footer() {
  const { t, lang } = useLang();
  return (
    <footer data-testid="site-footer" className="bg-[#030605] border-t border-[#1E2B25] mt-24">
      <div className="max-w-[1440px] mx-auto px-6 md:px-12 py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <img src={BRAND.logoUrl} alt="HC" className="h-16 mb-6" />
            <p className="font-serif-hc text-2xl md:text-3xl leading-tight text-[#F5F2EA] max-w-md">
              {t("footer.tag")}
            </p>
            <p className="mt-6 text-sm text-[#A3A095] max-w-md leading-relaxed">
              {CONTACT.LOCATION[lang]} · {CONTACT.HOURS[lang]}
            </p>
          </div>

          <div className="md:col-span-3">
            <p className="eyebrow mb-5">{t("footer.links")}</p>
            <ul className="space-y-3 text-[15px]">
              <li><Link to="/tours" className="text-[#F5F2EA] hover:text-[#C4A661] transition">{t("nav.tours")}</Link></li>
              <li><Link to="/experiencias" className="text-[#F5F2EA] hover:text-[#C4A661] transition">{t("nav.experiences")}</Link></li>
              <li><Link to="/nosotros" className="text-[#F5F2EA] hover:text-[#C4A661] transition">{t("nav.about")}</Link></li>
              <li><Link to="/faq" className="text-[#F5F2EA] hover:text-[#C4A661] transition">{t("nav.faq")}</Link></li>
              <li><Link to="/contacto" className="text-[#F5F2EA] hover:text-[#C4A661] transition">{t("nav.contact")}</Link></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <p className="eyebrow mb-5">{t("footer.legal")}</p>
            <ul className="space-y-3 text-[15px]">
              <li><a href="#" className="text-[#F5F2EA] hover:text-[#C4A661] transition">{t("footer.terms")}</a></li>
              <li><a href="#" className="text-[#F5F2EA] hover:text-[#C4A661] transition">{t("footer.privacy")}</a></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <p className="eyebrow mb-5">{t("footer.follow")}</p>
            <div className="flex flex-col gap-3">
              <a data-testid="footer-instagram" href={SOCIAL.INSTAGRAM_URL} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 text-[15px] text-[#F5F2EA] hover:text-[#C4A661]"><Instagram size={16}/> Instagram</a>
              <a data-testid="footer-facebook" href={SOCIAL.FACEBOOK_URL} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 text-[15px] text-[#F5F2EA] hover:text-[#C4A661]"><Facebook size={16}/> Facebook</a>
              <a data-testid="footer-tiktok" href={SOCIAL.TIKTOK_URL} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 text-[15px] text-[#F5F2EA] hover:text-[#C4A661]">TikTok</a>
              <a data-testid="footer-whatsapp" href={waLink()} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 text-[15px] text-[#25D366] hover:opacity-80"><MessageCircle size={16}/> WhatsApp</a>
            </div>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-[#1E2B25] flex flex-col md:flex-row justify-between gap-4 text-xs tracking-[0.18em] uppercase text-[#A3A095]">
          <span>© {new Date().getFullYear()} {BRAND.name}</span>
          <span>{t("footer.rights")}</span>
        </div>
      </div>
    </footer>
  );
}
